import '@grafana/ui';
import { CompletionItemKind, CompletionItemPriority } from '../types.js';

const toCompletionItem = (value, range, rest = {}) => {
  const item = {
    label: value,
    insertText: value,
    kind: CompletionItemKind.Field,
    sortText: CompletionItemPriority.Medium,
    range,
    ...rest
  };
  return item;
};

export { toCompletionItem };
//# sourceMappingURL=toCompletionItem.js.map
